export default "__VITE_ASSET__fd2cbd83__"